import React from "react";
import useTitanApp from "../../hooks/useTitanApp";
import { GoHomeFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import {
  setCurrentGlobalTabValue,
  setCurrentGlobalTabText,
  setisPatientSearched,
} from "../../dispatchers/appDispatchers";
import { setIsNewClinicComponent } from "../../dispatchers/pharmacyServiceDispatchers";
import { setIsPatientDashboard } from "../../dispatchers/patientDispatchers";
export default function PharmacyName() {
  const navigate = useNavigate();
  const { appState } = useTitanApp();
  const { currentPharmacy, darkMode, isPatientSearched, features } =
    appState || {};
  const { ifPharmacyDashboardEnabled } = features || {};

  const handleServicesKanbanRedirect = () => {
    setIsPatientDashboard(false);
    setisPatientSearched(false);
    setIsNewClinicComponent(false);
    setCurrentGlobalTabValue(0);
    setCurrentGlobalTabText(
      ifPharmacyDashboardEnabled ? "PharmacyDashboard" : "Services"
    );
    navigate(
      `/pharmacy/${ifPharmacyDashboardEnabled ? "dashboard" : "services"}/${
        currentPharmacy.teamPharmacyID
      }`
    );
  };

  return (
    <div className="pharmacy_name" onClick={handleServicesKanbanRedirect}>
      <GoHomeFill color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
      <h5>{currentPharmacy?.teamPharmacyName}</h5>
    </div>
  );
}
